/**
 * Geteilte Optionslisten der diatonischen Verschiebung – genutzt vom Ganz-Score-Panel
 * (`DiatonicShiftPanel.vue`, Endpunkt `POST /api/diatonic-shift`) **und** von der Auswahl-Variante in
 * der `ScoreEditToolbar` (clientseitig, `musicXmlDom.addDiatonicChordTonesInMusicXml`/
 * `reduceTriadsInMusicXml`). Die Intervall-Werte entsprechen `DIATONIC_INTERVAL_OPTIONS` der Engine
 * (`griffschrift/config/settings.py`); die Reduktionsmodi dem generierten `TriadReductionEnum`.
 */
import {OperationEnum, TriadReductionEnum} from '@/generated';

export const DIATONIC_INTERVAL_OPTIONS: ReadonlyArray<{ value: number; label: string }> = [
  {value: -8, label: 'Oktave ↓'},
  {value: -6, label: 'Sexte ↓'},
  {value: -5, label: 'Quinte ↓'},
  {value: -3, label: 'Terz ↓'},
  {value: -2, label: 'Sekunde ↓'},
  {value: 2, label: 'Sekunde ↑'},
  {value: 3, label: 'Terz ↑'},
  {value: 5, label: 'Quinte ↑'},
  {value: 6, label: 'Sexte ↑'},
  {value: 8, label: 'Oktave ↑'},
];

export const TRIAD_REDUCTION_OPTIONS: ReadonlyArray<{ value: TriadReductionEnum; label: string }> = [
  {value: TriadReductionEnum.LowMid, label: 'Tief + Mitte'},
  {value: TriadReductionEnum.LowHigh, label: 'Tief + Hoch'},
  {value: TriadReductionEnum.MidHigh, label: 'Mitte + Hoch'},
];

/** Die Operationen des Schritts – Beschriftung + Icon an EINER Stelle, damit Panel und Toolbar
 *  nicht auseinanderlaufen. `hint` erscheint als Unterzeile im Panel bzw. als `title` in der
 *  Toolbar. Reihenfolge = Anzeigereihenfolge. */
export const DIATONIC_OPERATION_OPTIONS: ReadonlyArray<{
  value: OperationEnum; label: string; hint: string; icon: string;
}> = [
  {
    value: OperationEnum.AddShiftedNotes,
    label: 'Noten hinzufügen',
    hint: 'Erzeugt eine zweite Stimme',
    icon: 'fa6-solid:plus',
  },
  {
    value: OperationEnum.ReduceTriadToDyad,
    label: 'Dreiklang reduzieren',
    hint: 'Reduziert Dreiklang auf Zweiklang',
    icon: 'fa6-solid:filter',
  },
  {
    value: OperationEnum.RemoveHighestNote,
    label: 'Höchste Note entfernen',
    hint: 'Entfernt aus jedem Akkord den obersten Ton',
    icon: 'fa6-solid:angles-up',
  },
  {
    value: OperationEnum.RemoveLowestNote,
    label: 'Niedrigste Note entfernen',
    hint: 'Entfernt aus jedem Akkord den untersten Ton',
    icon: 'fa6-solid:angles-down',
  },
];
